<template>
  <div id="product">
    <div class="banner text-center" data-i18n="home_service">系统集成与服务</div>
    <div class="container">
      <div class="product-container wow pulse">
        <el-tabs v-model="activeName" @tab-click="handleClick" stretch>
          <el-tab-pane
            v-for="(item, index) in items"
            style="font-size: 100px"
            :key="index"
            :label="item.name[lang] || item.name"
            :name="item.sort - 1 + ''"
          >
            <div id="bigData" class="container-fuild">
              <div
                class="row bigData-container wow slideInUp"
                v-for="(item, index) in product"
                v-bind:key="index"
              >
                <div v-if="index % 2 === 0">
                  <div class="col-xs-12 col-sm-12 col-md-6 wow zoomIn img-col">
                    <img
                      class="img-responsive"
                      :src="item.image"
                      alt="图片"
                      style="padding: 20px"
                    />
                  </div>
                  <div class="col-xs-12 col-sm-12 col-md-6 text-col">
                    <h2 class="bigData-title">
                      {{ item.name[lang] || item.name }}
                      <small>/ {{ item.name.en }}</small>
                    </h2>
                    <p style="font-size: 17px !important;" class="pcenter">{{ item.introduce[lang] || item.introduce }}</p>
                    <button @click="goToPage(item)" class="btnsty" data-i18n="homePage_mos">查看详情</button>
                  </div>
                </div>
                <div v-if="index % 2 === 1">
                  <div class="col-xs-12 col-sm-12 col-md-6 text-col">
                    <h2 class="bigData-title">
                      {{ item.name[lang] || item.name }}
                      <small>/ {{ item.name.en }}</small>
                    </h2>
                    <p style="font-size: 17px !important;" class="pcenter">{{ item.introduce[lang] || item.introduce }}</p>
                    <button @click="goToPage(item)" class="btnsty" data-i18n="homePage_mos">查看详情</button>
                  </div>
                  <div class="col-xs-12 col-sm-12 col-md-6 wow zoomIn img-col">
                    <img
                      class="img-responsive"
                      :src="item.image"
                      alt="图片"
                      style="padding: 20px"
                    />
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { websiteUrl, fileUrl } from "../../url.js";
import { translatePage } from '../assets/js/languages/change_language';
// 引入翻译变量
import { sharedState } from "../assets/js/languages/fanyi";
import { WOW } from "wowjs";

export default {
  name: "service",
  props: ["index"],
  data() {
    return {
      sort: "1",
      activeName: "0",
      items: [],
      product:[],
    };
  },
  mounted() {
    var wow = new WOW();
    wow.init();
    this.getProductlist();
    setTimeout(() => {
      translatePage()
    }, 50)
  },
  // 语言变量 计算属性
  computed: {
    lang() {
      return sharedState.lang;
    },
  },
  methods: {
    //根据id获取tabs数据
    async getProductlist() {
      //缓存
      const cache = localStorage.getItem("productlistData");
      if (cache) {
        this.items = JSON.parse(cache);
      }
      try {
        const response = await axios.get(
          `${websiteUrl}/mes-official-website-manage/listClass/list?belongList=1934505175448240129`
        );
        const data = response.data.rows;
        console.log(data[0].name);
        for (let index = 0; index < data.length; index++) {
          if (typeof data[index].name === "string") {
            data[index].name = JSON.parse(data[index].name);
          }
        }
        this.items = data;
        if (this.items.length > 0) {
          // 首页跳转时通过 ?tabIndex=N 指定初始 tab，越界则回退到第一个
          const q = Number(this.$route.query.tabIndex);
          const i = Number.isInteger(q) && q >= 0 && q < this.items.length ? q : 0;
          this.activeName = this.items[i].sort - 1 + "";
          this.activeTabId = this.items[i].id;
          this.getProduct(this.items[i].id);
          this.revealWow();
        }
        localStorage.setItem("productlistData", JSON.stringify(this.items));
      } catch (error) {
        console.error("获取数据失败:", error);
      }
    },
    // 根据tabs的id获取页面内容
    async getProduct(id) {
      console.log(id);
      const cache = localStorage.getItem("products");
      if (cache) {
        this.product = JSON.parse(cache);

        // for (let index = 0; index < this.product.length; index++) {
        //   const item = this.product[index];
        //   item.content = JSON.parse(item.content)
        // }

        console.log(this.product);
      }
      try {
        const response = await axios.get(
          `${websiteUrl}/mes-official-website-manage/listDetails/list?belongClass=${id}`
        );
        const data = response.data.rows;
        for (let index = 0; index < data.length; index++) {
          if (typeof data[index].name === "string") {
            data[index].name = JSON.parse(data[index].name);
            data[index].introduce = JSON.parse(data[index].introduce);
            data[index].content = JSON.parse(data[index].content.replaceAll("${baseUrl}", fileUrl));
            data[index].image = fileUrl + data[index].image;
          }
        }
        this.product = response.data.rows;
        console.log(this.product),"huoqu";
        localStorage.setItem("products", JSON.stringify(this.product));
      } catch (error) {
        console.error("获取数据失败:", error);
      }
    },
    handleClick(tab) {
      const selectedIndex = Number(tab.name);
      console.log(selectedIndex);
      if (this.items[selectedIndex]) {
        this.activeTabId = this.items[selectedIndex].id;
        this.getProduct(this.items[selectedIndex].id);
      }
      this.revealWow();
    },
    // WOW.js 会把初始化时处于隐藏 tab 里的元素设为 visibility:hidden，需触发一次 scroll 让它重新检测并显示
    revealWow() {
      this.$nextTick(() => window.dispatchEvent(new Event("scroll")));
    },
    goToPage(item) {
      console.log(item,"item111111111");
      // 跳转到对应的产品详情页面
      this.$router.push({
        name: "Service_left",
        params: {
          belongClass: item.belongClass,
          id: item.id,
        },
      });
    },
  },
};
</script>
<style>
/* element组件样式调整 */
.el-tabs__item:hover {
  color: #003987;
  cursor: pointer;
}

.el-tabs__item {
  font-size: 20px;
}

.el-tabs__item.is-active {
  color: #003987;
  font-size: 24px;
}

.el-tabs__active-bar {
  background-color: #003987;
}
</style>
<style scoped>
.banner {
  color: #fff;
  font-size: 30px;
  height: 400px;
  line-height: 400px;
  background-image: url("../assets/img/banner_al.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  background-attachment: scroll;
  background-position: center center;
}

#product {
  margin-top: 62px;
}
.product-container {
  padding: 30px 10px;
}

.product-item {
  margin-bottom: 30px;
}

.product-item-wrapper {
  cursor: pointer;
  background: rgba(244, 244, 244, 1);
  overflow: hidden;
  position: relative;
}

.product-item-top {
  width: 100%;
  height: 100px;
  padding: 30px;
  text-align: center;
  /* justify-content: center; */
  /* align-items: center; */
}

.product-item-top > i {
  display: block;
  margin-left: 43%;
  width: 25px;
  height: 2px;
  background: #003987;
  z-index: 999;
}

.product-item-top > p {
  color: #b2b2b2;
  opacity: 0;
  transform: translateY(10px);
  transition: all 0.5s ease;
  font-size: 24px;
}

.title {
  padding: 0 15px;
  color: #b2b2b2;
  /* opacity: 0; */
  /* transform: translateY(10px); */
  /* transition: all .5s ease; */
  font-size: 14px;
  text-indent: 4ch;
}

.product-item-img {
  width: 100%;
  /* height: 300px; */
  overflow: hidden;
}

.product-item-img img {
  width: 100%;
  transition: all 0.5s ease;
}

.product-item-border {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  z-index: 99;
  width: 100%;
  height: 100%;
  transition: all 0.5s ease;
  border: 1px solid #000;
  opacity: 0;
}

.product-item-wrapper:hover .product-item-top > i {
  opacity: 0;
}

.product-item-wrapper:hover .product-item-top > p {
  opacity: 1;
  transform: translateY(-10px);
}

.product-item-wrapper:hover .product-item-img > img {
  transform: scale(1.1, 1.1);
}

.product-item-wrapper:hover > .product-item-border {
  opacity: 1;
  width: 90%;
  height: 90%;
}
#bigData {
  padding: 60px;
}
.bigData-container {
  height: 380px;               /* 根据实际内容调整 */
  display: flex;
  align-items: stretch;       /* 让左右列高度一致 */
  margin-bottom: 50px;
  padding: 20px;
  box-shadow: 0 0 26px 0 rgba(0, 0, 0, 0.1);
}
/* 覆盖 Bootstrap 栅格列，使其高度占满父容器 */
.bigData-container .col-md-6 {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.bigData-container .text-col {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.bigData-container .text-col p {
  flex: 1;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  word-break: break-word;
}
.bigData-container .img-col {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
/* 图片固定尺寸，自适应比例，垂直居中 */
.bigData-container .img-col .img-responsive {
  max-width: 100%;
  height: 240px;          /* 固定高度，可根据设计调整 */
  object-fit: contain;    /* 保持比例，完整显示 */
  padding: 20px;
}
/* 图片容器固定高度，并确保图片自适应 */
.bigData-container .col-md-6 .img-responsive {
  width: 100%;
  height: 240px;              /* 固定图片区域高度 */
  object-fit: contain;        /* 图片等比缩放，完整显示（不裁剪） */
  padding: 20px;
  background-color: #f5f5f5;  /* 可选，纯色背景填充空白 */
}

/* 文本区域占据剩余空间，并将按钮推到底部 */
.bigData-container .col-md-6 h2,
.bigData-container .col-md-6 p {
  flex-shrink: 0;             /* 防止被压缩 */
}
.bigData-container .col-md-6 p {
  flex: 1;                    /* 占据剩余空间，让按钮靠下 */
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;      /* 显示3行，可修改 */
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  word-break: break-word;
}
#bigData .bigData-title {
  font-size: 30px;
}
#bigData .bigData-device {
  font-size: 30px;
  margin: 30px 0 15px;
}
#bigData p {
  font-size: 14px !important;
  color: #333 !important;
  line-height: 2.5rem !important;
  text-indent: 4ch;
}
#bigData .bigData-device {
  margin: 0 0 0 20px;
}
.btnsty {
  margin-top: auto;           /* 自动推到父容器底部 */
  width: 160px;
  background-color: #fff;
  border: 1px solid #003987;
  line-height: 40px;
  font-size: 16px;
  color: #003987;
  text-align: center;
  cursor: pointer;
  flex-shrink: 0;
}
.btnsty:hover {
  text-decoration: none;
  background-color: #003987;
  color: #fff !important;
  cursor: pointer;
}
@media screen and (max-width: 997px) {
  .product-container {
    margin: 20px 0;
    padding: 20px;
    border: 1px dashed salmon;
  }
}

</style>



// WEBPACK FOOTER //
// src/view/Service.vue